const LOCAL_STORAGE_KEY = 'subscriptions';

export const SUBSCRIPTION_LOCAL_STORAGE_KEYS = {
  CLUEY_PLUS_SUBS_BEING_CREATED: 'cluey_plus.subs_being_created', // for students who have a previous subscription, i.e. trial or paid
  CLUEY_PLUS_DISCOUNTED_SUBS_BEING_CREATED: 'cluey_plus.discounted_subs_being_created', // for apply discount flow
  CLUEY_PLUS_FREE_TRIAL_BEING_CREATED: 'cluey_plus.free_trial_being_created', // for newly added students who don't have any subscription at all
  CLUEY_PLUS_CANCEL_ENROLMENT_REQUESTED: 'cluey_plus.cancel_enrolment_requested',
  CLUEY_PLUS_CANCEL_SUBSCRIPTION_REQUESTED: 'cluey_plus.cancel_subscription_requested',
};

export class SubscriptionLocalStorage {
  static set(key: string, value: string): void {
    const existing = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) ?? '{}');
    const list: string[] = Array.isArray(existing[key]) ? existing[key] : [];
    if (!list.includes(value)) {
      list.push(value);
    }
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({ ...existing, [key]: list }));
  }

  static get(key: string): string[] {
    const existing = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) ?? '{}');
    return Array.isArray(existing[key]) ? existing[key] : [];
  }

  static remove(key: string, value: string): void {
    const existing = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) ?? '{}');
    const list: string[] = Array.isArray(existing[key]) ? existing[key] : [];
    const index = list.indexOf(value);
    if (index !== -1) {
      list.splice(index, 1);
    }
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({ ...existing, [key]: list }));
  }
}
